const config = {
  apiUrl: 'https://epos.kamranrasheed.com/api',
};

export default config;
